/**
 * MotoristaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {Motorista} from '@/model/resource/Motorista'

/* TODO: review generated class */
@HttpExclude()
export class MotoristaCollection extends PageCollection<Motorista> {
  constructor() {
    super(Motorista)
  }

  queryAsPage() {
    return this.listMotorista()
  }

  async listMotorista() {
    return await Request.get(`/admin/motorista`, {params: this.params})
      .name('listMotorista')
      .as(this)
      .getResponse()
  }

  async listCsvMotorista() {
    return await Request.get(`/admin/motorista/csv`, {params: this.params})
      .name('listCsvMotorista')
      .as(this)
      .getResponse()
  }
}
